/**
 * ID do contêiner do Google Tag Manager, fixo no código.
 * Vazio ("") significa: nenhum script do GTM sai no HTML.
 * Não vem do painel administrativo de propósito, para o script sair sempre
 * no HTML renderizado no servidor.
 */
export const GTM_ID = "GTM-W39VW8B7";
